import DealerAccountRequestFormReducer from "@gemeco/Store/Components/DealerAccountRequestForm/DealerAccountRequestFormReducer";
import DealerAccountRequestFormState from "@gemeco/Store/Components/DealerAccountRequestForm/DealerAccountRequestFormState";
import DefaultToOneTimeShipToReducer from "@gemeco/Store/Components/DefaultToOneTimeShipTo/DefaultToOneTimeShipToReducer";
import DefaultToOneTimeShipToState from "@gemeco/Store/Components/DefaultToOneTimeShipTo/DefaultToOneTimeShipToState";
import HeaderReducer from "@gemeco/Store/Pages/Header/HeaderReducer";
import HeaderState from "@gemeco/Store/Pages/Header/HeaderState";
import workOrderHistoryPageReducer from "@gemeco/Store/Pages/WorkOrderHistory/WorkOrderHistoryReducer";
import WorkOrderHistoryState from "@gemeco/Store/Pages/WorkOrderHistory/WorkOrderHistoryState";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

export type GemecoState = {
    dealerAccountRequestForm: DealerAccountRequestFormState;
    workOrderHistoryPageReducer: WorkOrderHistoryState;
    headerPage: HeaderState;
    defaultOneTimeShipTo: DefaultToOneTimeShipToState;
} & ApplicationState;

(reducers as any).workOrderHistoryPageReducer = workOrderHistoryPageReducer;
(reducers as any).dealerAccountRequestForm = DealerAccountRequestFormReducer;
(reducers as any).headerPage = HeaderReducer;
(reducers as any).defaultOneTimeShipTo = DefaultToOneTimeShipToReducer;
type Reducers = typeof reducers;

export type GemecoActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
